/**
 * Product UGC – Swiper carousel + video play (native, YouTube, Vimeo).
 */

(function() {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 1100px)');
  /** Base slides visible below 768px (e.g. 1.5 = peek). Tweak in breakpoints below. */
  var MOBILE_SLIDES_PER_VIEW = 1.5;
  var YT_ID_REGEX = /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([^&\s?#]+)/;
  var VIMEO_REGEX = /vimeo\.com\/(\d+)(?:\/([a-f0-9]+))?/;

  var swiperBySection = new WeakMap();

  function isBelowDesktop() {
    return !DESKTOP_MQ.matches;
  }

  function desktopSliderEnabled(sectionEl) {
    return sectionEl.getAttribute('data-ugc-desktop-slider') === 'true';
  }

  function shouldUseSwiper(sectionEl) {
    if (isBelowDesktop()) return true;
    return desktopSliderEnabled(sectionEl);
  }

  function destroySwiper(sectionEl) {
    var instance = swiperBySection.get(sectionEl);
    if (!instance) return;
    instance.destroy(true, true);
    swiperBySection.delete(sectionEl);
    sectionEl.classList.remove('product-ugc--has-swiper');
  }

  function buildSwiperOptions(sectionEl, carousel, slideCount) {
    var navPrev = sectionEl.querySelector('[data-ugc-prev]');
    var navNext = sectionEl.querySelector('[data-ugc-next]');
    var maxDesktopSlides = Math.min(4, slideCount);

    if (isBelowDesktop()) {
      return {
        slidesPerView: MOBILE_SLIDES_PER_VIEW,
        spaceBetween: 12,
        centeredSlides: false,
        grabCursor: true,
        watchOverflow: true,
        loop: slideCount > 1,
        loopedSlides: slideCount > 1 ? slideCount : undefined,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
            loop: slideCount > 2
          },
          800: {
            slidesPerView: 3,
            spaceBetween: 24,
            loop: slideCount > 3
          }
        }
      };
    }

    return {
      slidesPerView: maxDesktopSlides,
      spaceBetween: 30,
      centeredSlides: false,
      grabCursor: true,
      watchOverflow: true,
      loop: false,
      slidesPerGroup: 1,
      navigation: {
        nextEl: navNext,
        prevEl: navPrev
      }
    };
  }

  function initSwiper(sectionEl) {
    if (typeof Swiper === 'undefined') {
      setTimeout(function() { initSwiper(sectionEl); }, 100);
      return;
    }

    var carousel = sectionEl.querySelector('[data-ugc-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.swiper-slide');
    if (slides.length === 0) return;

    if (!shouldUseSwiper(sectionEl)) {
      destroySwiper(sectionEl);
      return;
    }

    if (swiperBySection.has(sectionEl)) return;

    var instance = new Swiper(carousel, buildSwiperOptions(sectionEl, carousel, slides.length));
    instance.on('breakpoint', function() {
      scheduleCaptionSync(sectionEl);
    });
    instance.on('resize', function() {
      scheduleCaptionSync(sectionEl);
    });
    swiperBySection.set(sectionEl, instance);
    sectionEl.classList.add('product-ugc--has-swiper');
  }

  function refreshSwiper(sectionEl) {
    destroySwiper(sectionEl);
    if (shouldUseSwiper(sectionEl)) initSwiper(sectionEl);
  }

  /** Equal caption box height per section (tallest quote); shorter text stays vertically centered. */
  function syncCaptionHeights(sectionEl) {
    var captions = sectionEl.querySelectorAll('.product-ugc__caption');
    if (!captions.length) return;

    captions.forEach(function(el) {
      el.style.height = 'auto';
    });

    var maxHeight = 0;
    captions.forEach(function(el) {
      maxHeight = Math.max(maxHeight, el.scrollHeight);
    });

    if (maxHeight > 0) {
      captions.forEach(function(el) {
        el.style.height = maxHeight + 'px';
      });
    }
  }

  function scheduleCaptionSync(sectionEl) {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        syncCaptionHeights(sectionEl);
      });
    });
  }

  function setOverlayVisibility(wrap, visible) {
    var poster = wrap.querySelector('[data-ugc-poster]');
    var playBtn = wrap.querySelector('[data-ugc-play]');
    var caption = wrap.querySelector('.product-ugc__caption');
    var buyer = wrap.querySelector('.product-ugc__buyer');
    var display = visible ? '' : 'none';

    if (poster) poster.style.display = visible ? 'block' : 'none';
    if (playBtn) playBtn.style.display = visible ? 'flex' : 'none';
    if (caption) caption.style.display = display;
    if (buyer) buyer.style.display = display;
  }

  function ensurePoster(wrap, src) {
    if (wrap.querySelector('[data-ugc-poster]')) return;
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.loading = 'lazy';
    img.width = 247;
    img.height = 439;
    img.decoding = 'async';
    img.setAttribute('data-ugc-poster', '');
    img.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;object-fit:cover;display:block';
    wrap.insertBefore(img, wrap.firstChild);
  }

  function lazyPosters(sectionEl) {
    sectionEl.querySelectorAll('[data-ugc-play]').forEach(function(btn) {
      var wrap = btn.closest('.product-ugc__media-wrap');
      if (!wrap) return;
      var host = btn.getAttribute('data-video-host');
      var url = btn.getAttribute('data-video-url');
      var id = btn.getAttribute('data-video-id');

      if (host === 'youtube' && url && !id) {
        var m = url.match(YT_ID_REGEX);
        if (m && m[1]) {
          btn.setAttribute('data-video-id', m[1]);
          ensurePoster(wrap, 'https://img.youtube.com/vi/' + m[1] + '/maxresdefault.jpg');
        }
      }
      if (host === 'vimeo' && url && !wrap.querySelector('[data-ugc-poster]')) {
        fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url) + '&maxwidth=1280')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            if (data && data.thumbnail_url) ensurePoster(wrap, data.thumbnail_url);
          })
          .catch(function() {});
      }
    });
  }

  function closeEmbedAndShowOverlay(wrap) {
    var iframe = wrap.querySelector('iframe');
    if (iframe) iframe.remove();
    setOverlayVisibility(wrap, true);
  }

  function pauseOthers(sectionEl, excludeWrap) {
    sectionEl.querySelectorAll('.product-ugc__media-wrap').forEach(function(w) {
      if (w === excludeWrap) return;
      var vid = w.querySelector('[data-ugc-mp4]');
      var iframe = w.querySelector('iframe');
      if (vid) {
        vid.pause();
        vid.setAttribute('hidden', '');
      }
      if (iframe) closeEmbedAndShowOverlay(w);
      else if (vid) setOverlayVisibility(w, true);
    });
  }

  function playNativeVideo(wrap, video, btn) {
    var videoUrl = video.getAttribute('data-video-url') || video.src || btn.getAttribute('data-file-url');
    if (!videoUrl && video.querySelector('source')) videoUrl = video.querySelector('source').src;
    if (videoUrl && video.src !== videoUrl) {
      video.src = videoUrl;
      var srcEl = video.querySelector('source');
      if (srcEl) srcEl.src = videoUrl;
    }

    setOverlayVisibility(wrap, false);
    video.removeAttribute('hidden');

    function doPlay() {
      try {
        video.currentTime = 0;
        var p = video.play();
        if (p !== undefined) {
          p.then(function() { btn.style.display = 'none'; }).catch(function() {
            video.setAttribute('hidden', '');
            setOverlayVisibility(wrap, true);
          });
        } else {
          btn.style.display = 'none';
        }
      } catch (e) {
        video.setAttribute('hidden', '');
        setOverlayVisibility(wrap, true);
      }
    }

    if (video.readyState >= 2) {
      doPlay();
    } else {
      var done = false;
      function onReady() {
        if (!done) { done = true; doPlay(); }
      }
      video.addEventListener('loadeddata', onReady, { once: true });
      video.addEventListener('canplay', onReady, { once: true });
      video.addEventListener('canplaythrough', onReady, { once: true });
      video.load();
      setTimeout(function() {
        if (!done && video.readyState >= 2) doPlay();
      }, 1000);
    }
  }

  function openEmbed(wrap, btn, embedUrl) {
    setOverlayVisibility(wrap, false);
    var iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;z-index:10';
    wrap.appendChild(iframe);
    btn.style.display = 'none';
  }

  function initVideoHandlers(sectionEl) {
    var playButtons = sectionEl.querySelectorAll('[data-ugc-play]');
    if (playButtons.length === 0) return;

    lazyPosters(sectionEl);

    playButtons.forEach(function(btn) {
      if (btn.dataset.ugcBound === '1') return;
      btn.dataset.ugcBound = '1';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = this.closest('.product-ugc__media-wrap');
        if (!wrap) return;
        pauseOthers(sectionEl, wrap);

        var video = wrap.querySelector('[data-ugc-mp4]');
        if (video) {
          playNativeVideo(wrap, video, this);
          return;
        }

        var host = this.getAttribute('data-video-host');
        var id = this.getAttribute('data-video-id');
        var url = this.getAttribute('data-video-url');
        var embedUrl = '';

        if (host === 'youtube') {
          if (!id && url) {
            var m = url.match(YT_ID_REGEX);
            id = (m && m[1]) ? m[1] : (url.match(/^.*(youtu\.be\/|v\/|\/u\/\w\/|embed\/|watch\?)\??v?=?([^#&?]*).*/) || [])[2];
          }
          if (id) embedUrl = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
          else if (url) { window.open(url, '_blank'); return; }
        } else if (host === 'vimeo') {
          if (!id && url) {
            var vm = url.match(VIMEO_REGEX);
            if (vm && vm[1]) id = vm[1];
          }
          var vimeoHash = this.getAttribute('data-vimeo-hash') || '';
          if (id) {
            embedUrl = 'https://player.vimeo.com/video/' + id + '?autoplay=1';
            if (vimeoHash) embedUrl += '&h=' + vimeoHash;
          } else if (url) { window.open(url, '_blank'); return; }
        } else if (url) {
          window.open(url, '_blank');
          return;
        }

        if (embedUrl) openEmbed(wrap, this, embedUrl);
      });
    });
  }

  function initSection(sectionEl) {
    if (!sectionEl || !sectionEl.classList.contains('product-ugc')) return;
    initVideoHandlers(sectionEl);
    refreshSwiper(sectionEl);
    scheduleCaptionSync(sectionEl);
  }

  function initAll() {
    document.querySelectorAll('.product-ugc.shopify-section').forEach(initSection);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('.product-ugc.shopify-section').forEach(function(el) {
        refreshSwiper(el);
        scheduleCaptionSync(el);
      });
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('resize', onResize);
  if (DESKTOP_MQ.addEventListener) {
    DESKTOP_MQ.addEventListener('change', onResize);
  }

  document.addEventListener('shopify:section:load', function() {
    initAll();
  });
})();
